<template>
  <div class="catelogue-product-items" id="product-items-grid" v-if="variations">
    <nav
      aria-label="breadcrumb"
      class="breadcrumbs"
      v-if="breadcrumbs.length > 0">
      <ol class="breadcrumb px-0 bg-transparent">
        <li class="breadcrumb-item">
          <a href="/">Home</a>
        </li>
        <li
          class="breadcrumb-item"
          v-bind:key="br.id"
          v-for="br in breadcrumbs">
          <a :href="br.alias">&nbsp;{{ br.label }}</a>
        </li>
      </ol>
    </nav>
    <span class="mobile-filter-icon"  @click="toggleFilter()" >Filters</span>
      <!-- <h1 @click="toggleFilter()"
        class="search-results-title text-align-center font-weight-bold text-uppercase"
        v-if="header !== ''">
        {{ header }}
      </h1> -->
      <h1 class="search-results-title text-align-center font-weight-bold text-uppercase"
        v-if="header !== ''">
        {{ header }}
      </h1>
    <div class="row">
      <div
        class="item col-xl-3 col-lg-6 col-md-6 col-sm-6"
        v-bind:key="index.id"
        v-for="(product, index) in productsLoaded">
        <a
          v-bind:class="{ featured: product.featured === '1' }"
          v-bind:href="product.url">
          <div class="jon-catelogue-content">
            <div class="jon-catelogue-tag">
              <div :class="['image', productClass(product)]">
                <img v-bind:src="product.image_url" v-bind:alt="product.sku" />
                <div class="quick-view-pop-up">
                  <a
                    href="javascript:void(0);"
                    class="quick-view-list"
                    v-bind:data-vid="product.id"
                    data-toggle="modal"
                    data-target="#quick-view-list">
                    <i class="fa-regular fa-eye"></i>
                  </a>
                </div>
              </div>
            </div>
            <div class="jon-catelogue-description">
              <b class="sku" v-text="product.sku"></b>
              <h3 class="title" v-text="product.title"></h3>
              <div class="compare-checkbox" v-if="compareEnable && product.type !== 'default_set'">
                <input
                  type="checkbox"
                  v-model="compareSelected"
                  v-on:change="change(product)"
                  v-bind:id="'compare-' + product.id"
                  v-bind:disabled="checkboxDisabled(product)"
                  v-bind:value="product.id"/>
                <label v-bind:for="'compare-' + product.id">Compare</label>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="load-more">
      <button
        @click="loadMore"
        v-if="
          productsLoaded.length <
          nonFeaturedProducts.length + featuredProducts.length
        "
      >
        Load More
      </button>
    </div>
    <div class="no-results-text" v-if="variations.length === 0">
      <h4>We couldn’t find any products matching your specifications.</h4>
      <p>Try clearing all filters and start a new search.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductList",
  props: {
    variations: Array,
    compareIds: Array,
    compareEnable: Boolean,
    header: String,
    breadcrumbs: Array,
  },
  data() {
    return {
      compareSelected: [],
      selectedType: "",
      show: false,
      length: 12,
    };
  },
  watch: {
    compareIds: function (newVal) {
      this.compareSelected = newVal;
    },
  },
  methods: {
    toggleFilter: function () {
      this.$emit("toggleFilter");
    },
    change: function (product) {
      const productType = product.type === "default_kit" ? "kit" : "product";
      if (this.compareSelected.length > 0) {
        this.selectedType = productType;
      } else {
        this.selectedType = "";
      }
      this.$emit("selectCompare", this.compareSelected);
    },
    checkboxDisabled: function (product) {
      const productType = product.type === "default_kit" ? "kit" : "product";
      if (this.compareSelected.length >= 10) {
        return true;
      }
      if (this.selectedType && productType !== this.selectedType) {
        return true;
      }
      return false;
    },
    loadMore() {
      if (this.length > this.variations.length) return;
      this.length = this.length + 12;
    },
    productClass(product) {
      let classes = [];

      if (product.award_winning_tag === "1") {
        classes.push("award-winning-tag");
      } else if (product.new_color_tag === "1") {
        classes.push("new-color-tag");
      } else if (product.coming_soon_tag === "1") {
        classes.push("coming-soon-tag");
      } else if (product.new_tool_tag === "1") {
        classes.push("new-tool-tag");
      }

      return classes.join(" ");
    },
  },
  computed: {
    productsLoaded() {
      // Filter and limit featured products to 9, then include others as per length
      const featuredProducts = this.variations
        .filter((product) => product.featured === "1")
        .slice(0, 9);
      const nonFeaturedProducts = this.variations.filter(
        (product) => product.featured !== "1"
      );
      return [...featuredProducts, ...nonFeaturedProducts].slice(
        0,
        this.length
      );
    },
    nonFeaturedProducts() {
      const nonFeaturedProducts = this.variations.filter(
        (product) => product.featured !== "1"
      );
      return [...nonFeaturedProducts];
    },
    featuredProducts() {
      const featuredProducts = this.variations
        .filter((product) => product.featured === "1")
        .slice(0, 9);
      return [...featuredProducts];
    },
  },
};
</script>
